/*
  Smooth scrolling via Lenis. Loaded from theme.liquid when the "Smooth
  scrolling" setting is enabled; the library itself is assets/lenis.min.js.

  Three cases where smooth scrolling doesn't start:
  - prefers-reduced-motion — a system request to remove motion;
  - theme editor — it has its own scroll-to-selected-section behavior that
    conflicts with Lenis;
  - an open drawer or modal — Dawn adds an overflow-hidden* class to <body>
    at that point, and the page shouldn't scroll underneath it.
*/

(function () {
  if (typeof Lenis === 'undefined') return;
  if (window.Shopify && window.Shopify.designMode) return;

  const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduceMotion.matches) return;

  const lenis = new Lenis({
    lerp: 0.12,
    smoothWheel: true,
    // Keep native scroll on touch devices: overriding inertia breaks system
    // expectations and is noticeably worse on low-end phones.
    syncTouch: false,
    // Let Lenis ease to the anchor itself — otherwise the browser jumps instantly
    // and the smooth scroll then catches up. This also covers Dawn's "Skip to content".
    anchors: true,
    // Dawn has its own scrollable panels that don't lock <body>: the dropdown
    // menu, collection filters, cart line items. Without this, the wheel would
    // scroll the page instead of the panel underneath it.
    allowNestedScroll: true,
    autoRaf: true,
  });

  // Dawn locks page scroll via a class on <body>: overflow-hidden for
  // modals, overflow-hidden-mobile / -tablet for the menu drawer.
  const isLocked = () =>
    Array.from(document.body.classList).some((name) => name.startsWith('overflow-hidden'));

  let locked = false;
  const syncLock = () => {
    const next = isLocked();
    if (next === locked) return;
    locked = next;
    if (locked) {
      lenis.stop();
    } else {
      lenis.start();
    }
  };

  new MutationObserver(syncLock).observe(document.body, {
    attributes: true,
    attributeFilter: ['class'],
  });
  syncLock();

  // The motion preference can change live — in that case stop for good.
  reduceMotion.addEventListener('change', (event) => {
    if (event.matches) lenis.destroy();
  });
})();
